module.exports = __webpack_public_path__ + "static/img/gold4.2223f5f7.png";